import { render, staticRenderFns } from "./OVO.vue?vue&type=template&id=5902c581&scoped=true"
import script from "./OVO.vue?vue&type=script&lang=js"
export * from "./OVO.vue?vue&type=script&lang=js"
import style0 from "./OVO.vue?vue&type=style&index=0&id=5902c581&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5902c581",
  null
  
)

export default component.exports